import { Amplify } from "aws-amplify";

/**
 * Amplify v6 bootstrap. Called once from main.tsx before React renders, so
 * every component tree sees a configured Cognito client.
 *
 * All values are Vite public env — user pool/client IDs are safe to ship in
 * the bundle (the token-issuing secret is the user's own password, and the
 * JWT is validated server-side). See .env.development and infra.md §6.11.
 */
export function configureAmplify(): void {
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  const identityPoolId = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID;

  if (!userPoolId || !userPoolClientId) {
    // Don't crash in dev/local where env may be half-populated — surface a
    // clear warning instead so developers fix .env.local.
    console.warn(
      "[amplify] VITE_COGNITO_USER_POOL_ID or VITE_COGNITO_CLIENT_ID is missing.",
    );
    return;
  }

  if (identityPoolId) {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId,
          userPoolClientId,
          identityPoolId,
          loginWith: { email: true },
        },
      },
    });
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: { email: true },
      },
    },
  });
}
